"use client";

import React from "react";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useAppsData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewHeroHeader } from "@/features/previews/shared/components";
import { Link } from "@/components/Link";
import { Typography } from "@/components/Typography";
import { IconList } from "@/components/IconList";
import { checkValidURL } from "@/utils/formHelper";

import "./AppsTemplate.scss";

export const AppsTemplate = (props: QRProps<"apps">) => {
  const {
    isInitialPreview,
    data,
    themeColor,
    appLinks,
    appsCompany,
    appsDescription,
    appsName,
    appsWebsite,
    logoUrl,
  } = useAppsData(props);

  if (!data) {
    return null;
  }

  return (
    <PhoneLayout
      page="apps"
      dataQA="preview-apps-container"
      backgroundColor={themeColor?.backgroundColor}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="apps-template">
        <PreviewHeroHeader
          variant="apps"
          logoUrl={logoUrl}
          title={appsName}
          subtitle={appsCompany}
          themeColor={themeColor}
          isInitialPreview={isInitialPreview}
          logoAlt="App Logo"
        />

        <div className="apps-template__content">
          <div
            className="apps-template__card u-card u-card--dark u-card--image u-card--center u-spacing-5"
            style={{ backgroundColor: themeColor?.buttonColor }}
          >
            <Typography
              Tag="p"
              size="s"
            >
              {appsDescription}
            </Typography>
            {appLinks && appLinks.length > 0 && (
              <div className="apps-template__links">
                <IconList
                  center
                  column
                  items={appLinks}
                />
              </div>
            )}
          </div>

          {appsWebsite && (
            <Link
              className="apps-template__website-link"
              href={checkValidURL(appsWebsite) || ""}
              externalLink
              prefetch={false}
            >
              {appsWebsite}
            </Link>
          )}
        </div>
      </div>
    </PhoneLayout>
  );
};
